<template>
  <div class="main-container">
    <div class="form-row">
      <div class="form-row-input">
        <ejs-textbox
          float-label-type="Always"
          ref="documentName"
          placeholder="Enter File Name..."
          :maxlength="250"
          v-model="fileName"
        />
        <div style="color: grey; font-size: 12px">
          <b>Note:</b> Do not use special characters: \\/:*?"&lt;>|
        </div>
        <label v-if="fileNameError" class="e-error">This field is required</label>
      </div>
      <div class="form-row-input fileController">
        <br />
        <br />
        <input
          type="file"
          @change="onFileSelection"
          ref="documentFileUploader"
          id="documentFileUploaderId"
        />
        <label v-if="uploadingDocumentError" class="e-error">This field is required</label>
      </div>
      <div class="form-row-input" v-if="showEditFileController">
        <br />
        <br />
        <a href="/forms/category" class="router-link-active"
          ><span class="side-nav-label">{{ editFileName }}</span></a
        >&nbsp;&nbsp;
        <a
          @click="removeIniliazedFile"
          href="#"
          class="e-delete-1 e-icons"
          style="margin-top: 2px"
        ></a>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { UploaderPlugin, NumericTextBoxPlugin } from "@syncfusion/ej2-vue-inputs";

Vue.use(UploaderPlugin);

Vue.use(NumericTextBoxPlugin);

export default {
  name: "formsCategoryDocumentModalContent",
  data() {
    return {
      showEditFileController: false,
      documentId: null,
      editFileName: null,
      files: null,
      fileType: null,
      orderId: 0,
      fileName: null,
      fileNameError: false,
      uploadingDocumentError: false,
    };
  },
  methods: {
    toggleFileController(isVisible) {
      document.getElementsByClassName("fileController")[0].style.display = isVisible
        ? "block"
        : "none";
    },
    showUploadController(isVisible) {
      const ele = document.getElementsByClassName("e-file-select-wrap");
      if (ele) {
        const controller = document.getElementsByClassName("e-file-select-wrap")[0];
        controller.style.display = isVisible ? "block" : "none";
      }
    },
    onFileSelection(e) {
      const selectedFile = e.target?.files[0];

      if (selectedFile) {
        this.uploadingDocumentError = false;
      }

      this.fileType = selectedFile.name
        ? selectedFile.name.substring(selectedFile.name.lastIndexOf(".") + 1)
        : "";
      if (selectedFile) {
        const reader = new FileReader();
        reader.readAsDataURL(selectedFile);
        reader.onload = (es) => {
          const contents = es.target.result;
          if (contents) {
            this.files = contents.substring(contents.indexOf(",") + 1);
          }
        };
      }
    },
    validateFileUploader() {
      this.fileNameError = !this.fileName;
      this.uploadingDocumentError = !!(!this.files || this.files.length < 1);
      if (!this.showEditFileController && (this.fileNameError || this.uploadingDocumentError)) {
        return null;
      }
      const result = {
        documentId: this.documentId,
        fileName: `${
          this.fileName.includes(".")
            ? this.fileName.substring(0, this.fileName.lastIndexOf("."))
            : this.fileName
        }.${this.getFileType()}`,
        orderId: this.orderId,
        file: this.files,
      };
      this.resetModal();
      return result;
    },
    getFileType() {
      if (!this.fileType) {
        return this.documentId
          ? this.editFileName.substring(this.editFileName.lastIndexOf(".") + 1)
          : null;
      }
      return this.fileType;
    },
    resetModal() {
      this.files = null;
      this.fileType = null;
      this.fileName = null;
      this.fileNameError = null;
      this.uploadingDocumentError = null;
      this.documentId = null;
      this.editFileName = null;
      document.getElementById("documentFileUploaderId").value = null;
      this.removeIniliazedFile();
    },
    removeIniliazedFile() {
      this.showEditFileController = false;
      this.toggleFileController(true);
    },
  },
  watch: {
    category() {
      return this.$store.getters.selectedCategory;
    },
  },
};
</script>
<style>
@import "../../../../node_modules/@syncfusion/ej2-base/styles/material.css";
@import "../../../../node_modules/@syncfusion/ej2-vue-inputs/styles/material.css";
</style>
